import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Typography from '../LandingComponents/Typography';
import LayoutBody from '../LandingComponents/LayoutBody';

import '../LandingMainPage/Overview.css'
import VisualizeDataEvolution from "../../assets/VisualizeDataEvolution.png"
import DiffQuery from "../../assets/DiffQuery.png"
import DataDedup from "../../assets/DataDedup.png"


const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit * 8,
  },
})


function DemoFeaturesComponents(props) {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <Typography variant="h3" gutterBottom marked="center" align="center">
        Demonstration
      </Typography>
      <div className="section_copy">
        <div className="conversation__description">
          <div className="description__heading">
            Visualize data evolution
          </div>
          <p className="description__text">
<b>Data versions </b>in ForkBase are generated according to the Merkle root hash
of data chunks, and encoded using the RFC 4648
Base32 alphabet. Such versioning
scheme enables ForkBase to provide <b>tamper evidence </b>against
malicious storage providers.
          </p>
        </div>
        <div className="img-container">
          <img src={VisualizeDataEvolution} alt="VisDataEvo" className="landing-img" />
        </div>
      </div>

      <div className="section_copy">
        <div className="conversation__description">
          <div className="description__heading">
            Differential query
          </div>
          <p className="description__text">
ForkBase supports fast differential query between data versions. <b>Data
differences are highlighted </b>at multiple scopes from
dataset to data entry. This resembles the Git-diff
utility to help user identify the changes of data.
          </p>
        </div>
        <div className="img-container">
          <img src={DiffQuery} alt="DiffQuery" className="landing-img" />
        </div>
      </div>

      <div className="section_copy">
        <div className="conversation__description">
          <div className="description__heading">
            Data deduplication
          </div>
          <p className="description__text">
When two datasets share a large portion of duplicated data, ForkBase can effectively
detect such redundancy and consequently<b> store only the marginal difference </b>into the underlying immutable storage for
the second loading.
          </p>
        </div>
        <div className="img-container">
          <img
            src={DataDedup}
            alt="DataDedup"
            className="landing-img"
          />
        </div>
      </div>

      <LayoutBody className={classes.root} component="section" width="large">
        <Typography variant="h4" marked="center" align="center" component="h2">
          ICDE 2020 Demo Paper
        </Typography>
        <div className="section_center">
          <div className="center__description">
            <iframe
              title='youtube-embed-forkbase'
              width="560" height="315"
              src="https://www.youtube.com/embed/8-wkF8nrLa0"
              frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen>
            </iframe>
            <p className="description__text">
ForkBase: Immutable, Tamper-evident Storage Substrate for Branchable Applications (Demo)<br />
Q. Lin, K. Yang, T. T. A. Dinh, Q. Cai, G. Chen, B. C. Ooi, P. Ruan, S. Wang, Z. Xie, M. Zhang, O. Vandans. <br />
<b>IEEE International Conference on Data Engineering (ICDE), 2020</b>
{' '}
            </p>
          </div>

        </div>
      </LayoutBody>
    </div>
  );
}

export default withStyles(styles)(DemoFeaturesComponents);
